var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z",
    fill: "#E9E7EC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6967 28.9866C23.0992 28.308 22.8028 27.4644 22.8028 26.4606C22.8028 26.0223 22.8545 25.5227 22.958 24.9713C23.0615 24.4152 23.1744 23.878 23.2874 23.3549C23.4003 22.8317 23.4803 22.4971 23.5226 22.351C23.6873 21.6206 23.8472 20.8995 23.9931 20.1879C24.1389 19.4762 24.2142 18.9013 24.2142 18.463C24.2142 17.3979 23.8378 16.8607 23.085 16.8607C22.5393 16.8607 22.0594 17.1293 21.6454 17.6618C21.2266 18.1944 20.8926 18.8919 20.6432 19.7496L18.5119 29.8255H14L17.3216 14.1272H21.8336L21.4901 15.7579C22.5346 14.5844 23.7578 14 25.1552 14C26.2185 14 27.0653 14.2922 27.6911 14.8766C28.3168 15.461 28.6321 16.3517 28.6321 17.544C28.6321 18.152 28.5568 18.8259 28.4109 19.5658C28.2651 20.3104 28.0534 21.2153 27.7852 22.2804C27.6158 22.9307 27.4653 23.5622 27.3288 24.1796C27.1924 24.797 27.1265 25.2824 27.1265 25.6406C27.1265 26.06 27.2206 26.3852 27.4088 26.6114C27.597 26.8423 27.9216 26.9554 28.378 26.9554C29.0037 26.9554 29.5072 26.7292 29.8835 26.2815C30.2599 25.8338 30.6363 25.1363 31.0127 24.1937H32.3301C31.5585 26.4936 30.6645 28.0394 29.653 28.8217C28.6415 29.604 27.5923 29.9999 26.5055 29.9999C25.2305 29.9999 24.2989 29.6606 23.7014 28.9819L23.6967 28.9866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.7347 32.4282C36.9496 30.7275 38.9367 30 40.9568 30C42.9768 30 45.9999 30.5781 45.9999 36.3161V45.9999H41.4889V37.0725C41.4889 35.5549 41.3429 33.0978 38.9367 33.0978C35.9702 33.0978 35.909 36.6486 35.909 37.3182V45.9999H31.3979V30.5781H35.73V32.4282H35.7347Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user_default.5cd9eddd6deb50fc1124a65fef581354.svg";
export { ForwardRef as ReactComponent };